import { UnsuccessfulFetchError } from './unsuccessful-fetch-error';

export async function mapResponseToText(response: Response): Promise<string> {
	if (response.ok) {
		return await response.text();
	} else {
		throw new UnsuccessfulFetchError({
			message: await mapResponseToMessage(response),
			response,
		});
	}
}

export async function mapResponseToJson<T = unknown>(response: Response): Promise<T> {
	if (response.ok) {
		return await response.json();
	} else {
		throw new UnsuccessfulFetchError({
			message: await mapResponseToMessage(response),
			response,
		});
	}
}

export async function errorHandleResponse(response: Response): Promise<undefined> {
	if (response.ok) {
		return;
	}
	throw new UnsuccessfulFetchError({
		message: await mapResponseToMessage(response),
		response,
	});
}

async function mapResponseToMessage(response: Response): Promise<string> {
	const { statusText } = response;
	const message = await response.text();
	if (message.length > 0) {
		return `${statusText} ${message}`;
	} else {
		return statusText;
	}
}

export async function getErrorMessageFromJson(response: Response): Promise<string | null> {
	try {
		const errorResponse = await response.json();
		if (errorResponse.error) {
			return errorResponse.error;
		}
		return null;
	} catch {
		return null;
	}
}

export async function getErrorMessageFromText(response: Response): Promise<string | null> {
	try {
		const errorText = await response.text();
		return errorText || null;
	} catch {
		return null;
	}
}

export async function getErrorMessage(response: Response): Promise<string> {
	const errorMessageFromJson = await getErrorMessageFromJson(response);
	if (errorMessageFromJson) {
		return errorMessageFromJson;
	}

	const errorMessageFromText = await getErrorMessageFromText(response);
	if (errorMessageFromText) {
		return errorMessageFromText;
	}

	return '';
}
